var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextColorPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8348 8.68571C16.7122 8.42009 16.4463 8.25 16.1538 8.25C15.8612 8.25 15.5954 8.42009 15.4728 8.68571L11.319 17.6857C11.1454 18.0618 11.3096 18.5074 11.6856 18.681C12.0617 18.8545 12.5073 18.6904 12.6809 18.3143L13.7578 15.981L18.5497 15.981L19.6267 18.3143C19.8002 18.6904 20.2458 18.8545 20.6219 18.681C20.998 18.5074 21.1622 18.0618 20.9886 17.6857L16.8348 8.68571ZM17.8574 14.481L16.1538 10.7897L14.4501 14.481L17.8574 14.481Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextColorPicker);
export default __webpack_public_path__ + "static/media/text_color_picker.9219607a29a20114a4e828571c05c554.svg";
export { ForwardRef as ReactComponent };